import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  InformationBox,
  MuiBox,
  MuiButtonPrimary,
  MuiButtonSecondary,
  MuiGrid,
  MuiModal,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { ProjectInvoiceHistory } from "../../../createProject/components/invoiceHistory/ProjectInvoiceHistoryMain";
import { createNewProjectHeaderSiteCoreKeys, projectInvoiceHistorySiteCoreKeys } from "../../../createProject/siteCore/SiteCoreKeys";
import { ViewProjectHeaderWrapper } from "./ViewProjectHeader.style";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";
import { projectCountryPermissionSelector } from "../../../../redux/slices/project/projectSelector";

const ViewProjectHeader: React.FC<{
  projectId: string;
  onEditClick?: () => void;
}> = ({ projectId, onEditClick }) => {
  const isEditable = useSelector(projectCountryPermissionSelector);
  const { commonLabels, fetchLabel, fetchComponentTitle } = useSiteCore();
  const [showInvoiceHistoryModal, setShowInvoiceHistoryModal] = useState(false);

  return (
    <ViewProjectHeaderWrapper>
      <MuiBox className="header-container">
        <MuiGrid
          size={{ sm: 4, xs: 12 }}
          className="header-left"
          data-testid="view-program-template-header"
        >
          <InformationBox
            title={fetchLabel(
              createNewProjectHeaderSiteCoreKeys.createNewProjectHeader,
              createNewProjectHeaderSiteCoreKeys.viewProjectHeader,
            )}
          />
        </MuiGrid>
        <MuiGrid className="button-group">
          <PermissionWrapper
            permission={MODULE_PERMISSIONS.PROJECT_VIEW_INVOICE_HISTORY}
          >
            <MuiButtonSecondary
              onClick={() => setShowInvoiceHistoryModal(true)}
            >
              {fetchLabel(
                createNewProjectHeaderSiteCoreKeys.createNewProjectHeader,
                createNewProjectHeaderSiteCoreKeys.viewInvoiceHistoryButton,
              )}
            </MuiButtonSecondary>
          </PermissionWrapper>
          {isEditable && (
            <MuiButtonPrimary
              onClick={onEditClick}
              className="header-edit-button"
              id="edit-btn"
            >
              {commonLabels.edit}
            </MuiButtonPrimary>
          )}
        </MuiGrid>

        {showInvoiceHistoryModal && (
          <MuiModal
            hasLargeContent
            open={showInvoiceHistoryModal}
            onClose={() => setShowInvoiceHistoryModal(false)}
            title={fetchComponentTitle(
              projectInvoiceHistorySiteCoreKeys.invoiceHistoryTitle,
            )}
            primaryButtonTitle={commonLabels.ok}
            onPrimaryButtonClick={() => setShowInvoiceHistoryModal(false)}
          >
            <ProjectInvoiceHistory projectId={projectId} isViewOnly={true} />
          </MuiModal>
        )}
      </MuiBox>
    </ViewProjectHeaderWrapper>
  );
};

export default ViewProjectHeader;
